import { render, staticRenderFns } from "./TextBlockControl.vue?vue&type=template&id=618cf6e2"
import script from "./TextBlockControl.vue?vue&type=script&lang=js"
export * from "./TextBlockControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports